import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminFormComponent } from './admin.component';
import { CustomerUserInfoFormModule } from '../../../../../../customer/customer-basic-info/customer-user-info-form/customer-user-info-form.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { UserSearchDialogModule } from '../../../../../../shared/dialogs/user-search-dialog/user-search-dialog.module';
import { MatButtonModule } from '@angular/material/button';
import { ListGridModule } from '../../../../../../shared/listGrid/listGrid.module';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
  imports: [
    CommonModule,
    CustomerUserInfoFormModule,
    UserSearchDialogModule,
    FlexLayoutModule,
    MatButtonModule,
    ListGridModule,
    MatToolbarModule,
  ],
  declarations: [AdminFormComponent],
  entryComponents: [],
  exports: [AdminFormComponent],
  providers: [],
})
export class AdminFormModule {}
